var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head-body navy"},[_c('div',{staticClass:"gift-title my-5"},[_vm._v("Buy Selflane Gift Cards")]),_c('div',{staticClass:"gift-subtitle my-5"},[_vm._v("Use anytime at any restaurant")])])
}]

export { render, staticRenderFns }